import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import CompanyPackages from '../../components/CompanyPackages';
import CompanyFormationPricing from '../../components/CompanyFormationPricing';

const CompanyFormation = () => {
  const usps = [
    {
      title: 'Complete Business Setup',
      description: 'We handle everything from filing articles of incorporation to obtaining your EIN. Launch your business with a solid legal foundation and expert guidance every step of the way.'
    },
    {
      title: 'LLC & Corporation Formation',
      description: 'Whether you need an LLC for flexibility or a corporation for raising capital, we guide you to the right business structure and handle all state filings seamlessly.'
    },
    {
      title: 'Fast State Filing',
      description: 'Operating in all 50 states, we ensure rapid filing with your state\'s Secretary of State office. Get your business up and running quickly without compromising on legal compliance.'
    },
    {
      title: 'Ongoing Compliance Support',
      description: 'Beyond formation, we provide registered agent services, compliance guidance, and annual report filing to keep your business in good standing with state authorities.'
    }
  ];

  const whyChooseContent = {
    about: 'Company formation establishes your business as a legal entity separate from its owners, providing liability protection and tax benefits. Whether forming an LLC, Corporation, or other entity type, proper formation is essential for business success and legal compliance.',
    intro: 'Starting a business shouldn\'t be complicated. Trademark Vector makes company formation simple, affordable, and stress-free for entrepreneurs nationwide.',
    paragraph1: 'Our business formation services cover everything—from choosing the right entity structure to filing with the state and obtaining your federal tax ID. We\'ve helped thousands of entrepreneurs launch their businesses with confidence and proper legal protection.',
    paragraph2: 'With transparent pricing and expert guidance at every step, you can focus on what matters most—growing your business. We handle the legal complexities while you pursue your entrepreneurial dreams.'
  };

  return (
    <ServiceTemplate
      title="Company Formation"
      subtitle="Start Your Business with Expert Company Formation Services"
      description="Form your LLC or Corporation quickly and affordably. Our comprehensive formation services include everything you need to establish your business legally and start operating with confidence."
      heroImage="https://images.unsplash.com/photo-1603796846097-bee99e4a601f"
      aboutImage="https://images.unsplash.com/photo-1758518729371-5ee28c4ddf60?w=800"
      serviceId="company-formation"
      metaTitle="LLC & Corporation Formation in All 50 States | Trademark Vector"
      metaDescription="Launch your business the right way. We form LLCs & Corporations, handle state filings, obtain your EIN & provide ongoing compliance support nationwide."
      usps={usps}
      whyChooseContent={whyChooseContent}
      customSection={<CompanyPackages />}
      hidePricing={true}
    />
  );
};

export default CompanyFormation;
